import { VISITOR_FEEDBACK_OPTIONS, FALLBACK_TEXT } from 'Src/constants'

export const getVisitorFeedbackLabel = (value) => {
  const label = VISITOR_FEEDBACK_OPTIONS.find(({ value: optionValue }) => optionValue === value)?.label
  return label || FALLBACK_TEXT
}
